import { Component, inject, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import {
  IonButton,
  IonContent,
  IonInput,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { SlideModalController } from '../../../../../../slide-modal.service';
import { P0003605EnSavoirPlusDosageComponent } from '../../../P0003605/InjectionChlore/EnSavoirPlus/p0003605-en-savoir-plus-dosage/p0003605-en-savoir-plus-dosage.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P0003605PositionTypeEnum } from '../../../P0003605/Enum/P0003605PositionTypeEnum';

@Component({
  selector: 'app-p00076-installation-consommation',
  templateUrl: './p00076-installation-consommation.component.html',
  styleUrls: ['./p00076-installation-consommation.component.scss'],
  imports: [
    FormsModule,
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    IonInput,
    LabelDescriptionComponent,
    LargedLinkComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class P00076InstallationConsommationComponent implements OnInit {
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  public currentForm: FormGroup | null = null;

  private modalController = inject(ModalController);
  private slideModalController = inject(SlideModalController);
  private fb = inject(FormBuilder);
  private edroNetworkManager = inject(EdroNetworkManager);

  private defaultData: any = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.initForm();
  }

  private initForm() {
    this.defaultData = JSON.stringify({
      surface: Number(
        this.actionStack!.getValue('coISurfaceBassin') || 0,
      ).toFixed(0),
    });

    console.log(this.defaultData);

    this.currentForm = this.fb.group({
      surface: [
        Number(this.actionStack!.getValue('coISurfaceBassin') || 0).toFixed(0),
        [Validators.required, Validators.pattern('^[0-9]+([.,][0-9]+)?$')],
      ],
    });
  }

  // Méthode pour ajuster la valeur du débit au blur
  onSurfaceBlur(event: any) {
    let valueStr = event.target.value.replace(',', '.'); // Normalise la virgule
    let value = parseFloat(valueStr);

    if (isNaN(value) || value <= 0) {
      value = 0;
    } else if (value >= 999.5) {
      value = 999.5;
    }

    // Formate avec 1 décimale si nécessaire
    this.currentForm!.controls['surface'].setValue(
      parseFloat(value.toFixed(1)),
    );
  }

  onSubmit() {
    var data = {
      surface: this.currentForm!.controls['surface']?.value,
    };

    if (JSON.stringify(data) !== this.defaultData) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Constance_Installation,
        'coISurfaceBassin',
        parseFloat(data.surface),
        null,
      );
    }

    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P0003605PositionTypeEnum = P0003605PositionTypeEnum;
}
